import React, { Component } from 'react'

import cx from "classnames";
import styles from "./style.module.scss";

import { localizedStrings } from 'src/localization';

class ViewMoreLess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      clamped: false
    }

    this.localizedCommons = localizedStrings.commons;
    this.localizedCollection = localizedStrings.pages.collections.collection;

  }

  componentDidMount() {
    this.calculateViewMoreLess();
  }

  componentWillUnmount() {
    const parentDiv = document.querySelector(".viewMoreLess");
    if (parentDiv) {
      parentDiv.classList.remove(styles.clamp)
    }
  }

  calculateViewMoreLess() {
    const hasClamping = (el) => {
      const { clientHeight, scrollHeight } = el;
      return clientHeight !== scrollHeight;
    };

    const checkButtonAvailability = () => {
      const parentDiv = document.querySelector(".viewMoreLess");
      if (parentDiv) {
        const hadClampClass = parentDiv.classList.contains(styles.clamp);
        if (!hadClampClass) parentDiv.classList.add(styles.clamp);
        var clamped = hasClamping(parentDiv);

        this.setState({
          show: clamped,
          clamped: !hadClampClass
        });
        if (hadClampClass) parentDiv.classList.remove(styles.clamp);
      }
    };

    checkButtonAvailability();

  }

  handleClick() {
    this.calculateViewMoreLess();
    if (this.props.isFromAsset) {
      var element = document.querySelector(".viewMoreLess");
      if(element)
      {
        element.scroll({ top: element.scrollHeight, behavior: 'smooth' });
      }
    } else {
      var element = document.getElementById("templateContent").lastElementChild;
      element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }

  handleShowLess() {
    this.calculateViewMoreLess();
    if (this.props.isFromAsset) {
      var element = document.getElementById("templateContent");
      if(element)
      {
        element.scroll({ top: 0 })
      } 
    } else {
      var element = document.getElementById("templateContent").firstElementChild;
      element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }
  
  render() {
    return (
      <div>
        {this.props.children}
        <span
          className={cx(styles.viewMoreLessButton, this.props.className, {[styles.hide]: !this.state.show})}
          onClick={this.handleClick.bind(this)}
        >
          {this.state.clamped && this.localizedCollection.commons.actions.see_more }
        </span>
          {!this.state.clamped && <span onClick={this.handleShowLess.bind(this)} className={styles.viewMoreLessButton}>{ this.localizedCollection.commons.actions.see_less}</span>}
      </div>

    )
  }
}

export default ViewMoreLess